export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="lg:w-1/2 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              移动观影
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              神马视频全面适配移动端浏览，无需下载APP，手机浏览器直接访问即可享受流畅观影体验。西瓜视频免费、菠萝视频、青青草视频等平台资源在手机上同样高清不缓冲，随时随地想看就看。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-lg">
                <i className="ri-smartphone-line text-primary-500 text-lg"></i>
                <span className="text-sm text-foreground-700">手机端适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-lg">
                <i className="ri-tablet-line text-accent-500 text-lg"></i>
                <span className="text-sm text-foreground-700">平板适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-lg">
                <i className="ri-computer-line text-secondary-500 text-lg"></i>
                <span className="text-sm text-foreground-700">电脑端适配</span>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2 flex justify-center">
            <div className="relative w-[240px] h-[480px] rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20smartphone%20mockup%20displaying%20abstract%20cinematic%20entertainment%20interface%2C%20warm%20orange%20and%20gold%20UI%20theme%2C%20clean%20minimal%20mobile%20app%20design%2C%20soft%20ambient%20lighting%2C%20no%20recognizable%20content%2C%20no%20text&width=480&height=960&seq=app-01-2026&orientation=portrait"
                alt="神马视频移动端观影体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}